import React from "react";
import { useNavigate } from "react-router-dom";

export default function NotFound({ rideIdUndefined = false }) {
  return (
    <div className="h-screen flex items-center justify-center bg-white dark:bg-gray-900">
      <div className="text-center px-6 max-w-lg mx-auto">
        {/* 404 with colored numbers and glitch effect */}
        <div className="flex justify-center items-center space-x-2 mb-8">
          <div className="text-8xl font-bold text-yellow-500">4</div>
          <div className="text-8xl font-bold text-red-500">0</div>
          <div className="text-8xl font-bold text-blue-500">4</div>
        </div>

        {/* Error messages */}
        <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-white">
          {rideIdUndefined ? "Ride ID" : ""} Not Found
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mb-8">
          The page you are looking for was moved, removed, renamed
          <br />
          or might never existed!
        </p>
      </div>

      {/* Decorative elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0">
          {/* Small colored lines scattered around */}
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className={`absolute h-1 w-4 rounded-full
                         ${i % 3 === 0 ? "bg-yellow-500" : i % 3 === 1 ? "bg-red-500" : "bg-blue-500"}`}
              style={{
                top: `${Math.random() * 100}%`,
                left: `${Math.random() * 100}%`,
                transform: `rotate(${Math.random() * 360}deg)`,
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
